import { FuseAnimate, FuseScrollbars, FuseSplashScreen } from "@fuse";
import Loading from "@fuse/components/FuseLoadable/Loading";
import { AppBar, Avatar, withStyles, DialogContent, ListItemIcon, ListItemText, Menu, MenuItem, Paper, TextField, Toolbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import { getAcronimo, isHoje, smartDateFormat } from "app/Core/Helpers";
import Axios from "axios";
import clsx from 'clsx';
import dayjs from "dayjs";
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { MdInfoOutline } from "react-icons/md";
import { MensagemRSS } from "../../Components/MensagemRSS";
import Resposta from "./Resposta";

const styles = theme => ({
    content: {
        height: '75%',
        maxHeight: '75%',
    },
    bgPaper: {
        backgroundColor: theme.palette.background.paper
    },
    btnOpcoes: {
        backgroundColor: theme.palette.primary.main,
    },
    messageRow: {
        '& a': {
            color: `${theme.palette.primary.contrastText} !important`,
            '&:hover': {
                color: `${theme.palette.primary.contrastText} !important`,
            },
        },
        '&.contact': {
            paddingRight: 40,
            '& .bubble': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                borderTopRightRadius: 20,
                borderBottomRightRadius: 20,
                '& .time': {
                    display: 'flex',
                    justifyContent: "end",
                }
            },
            '&.first-of-group': {
                '& .bubble': {
                    borderTopLeftRadius: 20
                }
            },
            '&.last-of-group': {
                '& .bubble': {
                    borderBottomLeftRadius: 20
                }
            },
            '& .bubble:hover .btn-opcoes': {
                "display": "block",
                backgroundColor: theme.palette.primary.main,
            },
            '& .btn-opcoes': {
                "display": "none"
            }
        },
        '&.me': {
            paddingLeft: 40,
            '& .bubble': {
                marginLeft: 'auto',
                backgroundColor: theme.palette.primary.dark,
                color: theme.palette.primary.contrastText,
                borderTopLeftRadius: 20,
                borderBottomLeftRadius: 20,
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                '& .time': {
                    display: "flex",
                    justifyContent: "end",
                    marginRight: 12
                }
            },
            '&.first-of-group': {
                '& .bubble': {
                    borderTopRightRadius: 20
                }
            },
            '&.last-of-group': {
                '& .bubble': {
                    borderBottomRightRadius: 20
                }
            },
            '& .bubble:hover .btn-opcoes': {
                "display": "block",
                backgroundColor: theme.palette.primary.dark,
            },
            '& .btn-opcoes': {
                "display": "none"
            }
        },
        '&.first-of-group': {
            '& .bubble': {
                borderTopLeftRadius: 20,
                paddingTop: 5
            }
        },
        '&.last-of-group': {
            '& .bubble': {
                borderBottomLeftRadius: 20,
                padding: "5px 0px",
            }
        }
    },
});

const Chat = (props) => {
    const { save, updateDataLeitura = null, data = null, user, classes } = props;
    const [interacao, setInteracao] = useState("");
    const [updated, setUpdated] = useState(false);

    useEffect(() => {
        let div = document.getElementById("chatContent");
        if (!updated && !_.isNull(data) && !_.isNull(data.interacoes) && data.lido === 0 && div.offsetHeight === div.scrollHeight && !_.isNull(updateDataLeitura)) {
            let ADataLeitura = !_.isNull(data.interacoes) ? data.interacoes[data.interacoes.length - 1].datains : new Date().toISOString();
            updateDataLeitura(data, ADataLeitura);
        }
        div.scrollTop = div.scrollHeight;
    }, [data]);

    function enviar() {
        save({ "idmensagem": data.idmensagem, "interacao": interacao }, "INSERIRINTERACAO");
        setInteracao("");
    }

    function isFirstMessageOfGroup(item, i) {
        return (i === 0 || (data.interacoes[i - 1] && data.interacoes[i - 1].usrins !== item.usrins));
    };

    function isLastMessageOfGroup(item, i) {
        return (i === data.interacoes.length - 1 || (data.interacoes[i + 1] && data.interacoes[i + 1].usrins !== item.usrins));
    };

    function onScrollDown() {
        let div = document.getElementById("chatContent");
        if (!updated && checkNaoLidas(data.interacoes) && (div.offsetHeight + div.scrollTop >= div.scrollHeight)) {
            setUpdated(true);
            let ADataLeitura = !_.isNull(data.interacoes) ? data.interacoes[data.interacoes.length - 1].datains : new Date().toISOString();
            updateDataLeitura(data, ADataLeitura);
        }
    }

    function checkNaoLidas(_AInteracoes = []) {
        return (_.filter(_AInteracoes, { lido: 0 })).length > 0;
    }

    return (
        <React.Fragment>
            {!_.isNull(data) &&
                <FuseAnimate animation="transition.slideDownIn" delay={300}>
                    <div className="w-full min-h-full">
                        <div className="header border-b-1 pb-4 mb-4">
                            <div className="flex">
                                <span className={clsx(" w-full whitespace-no-wrap")}>
                                    {data.remetente}
                                </span>
                                <span className={clsx(" w-fit text-11 whitespace-no-wrap")}>
                                    {smartDateFormat(data.dataupt)}
                                </span>
                            </div>
                            <span className={clsx(" w-full whitespace-no-wrap")}>
                                {`Ref: ${!_.isNull(data.assunto) ? data.assunto : ""}`}
                            </span>
                        </div>
                        <div className={clsx(classes.content, "flex flex-col h-inherit relative", data.status !== 0 && "max-h-4/5")}>
                            <FuseScrollbars id="chatContent" className="flex flex-1 flex-col overflow-y-auto h-inherit pr-16" onScrollDown={() => onScrollDown()}>
                                {!_.isNull(data.interacoes) && data.interacoes?.map((item, x) => {
                                    return (
                                        <>
                                            {item.interacao.includes("json=1") ?
                                                <MensagemRSS
                                                    item={item}
                                                    classes={classes}
                                                />
                                                :
                                                <div
                                                    key={item.idmensageminteracao}
                                                    className={clsx(
                                                        classes.messageRow,
                                                        "flex flex-col flex-no-grow flex-no-shrink items-start justify-end relative pb-4",
                                                        { 'me': item.usrins === user.usuario },
                                                        { 'contact': item.usrins !== user.usuario },
                                                        { 'first-of-group': isFirstMessageOfGroup(item, x) },
                                                        { 'last-of-group': isLastMessageOfGroup(item, x) }
                                                    )}
                                                >
                                                    <div
                                                        className="bubble flex flex-col min-h-48 min-w-88 relative max-w-full justify-between"
                                                    >
                                                        <MenuOpcoes
                                                            interacao={item}
                                                        />
                                                        {item.usrins !== user.usuario && !_.isNull(item.nome) && isFirstMessageOfGroup(item, x) &&
                                                            <Typography
                                                                className="w-full text-10 px-16 whitespace-no-wrap text-white leading-none capitalize"
                                                                color="textSecondary"
                                                            >
                                                                {item.nome.toLowerCase()}
                                                            </Typography>
                                                        }
                                                        <div
                                                            className={clsx("leading-tight whitespace-pre-wrap mx-12 my-4")}
                                                            dangerouslySetInnerHTML={{ __html: item.interacao }}
                                                        />
                                                        <Typography
                                                            className="time w-full text-10 px-16 mb-4 whitespace-no-wrap text-white leading-none"
                                                            color="textSecondary"
                                                        >
                                                            {smartDateFormat(item.datains)}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    );
                                })}
                                {data.status === 2 &&
                                    <div className="flex items-end flex-col w-full pb-6">
                                        {!_.isNull(data.respostas) && data.respostas?.map((item, x) =>
                                            <Resposta
                                                data={item}
                                                enviar={ev => save({ "idmensagem": data.idmensagem, "interacao": ev }, "INSERIRINTERACAO")}
                                            />
                                        )}
                                    </div>
                                }
                            </FuseScrollbars>
                        </div>
                        {data.status === 0 &&
                            <div className={clsx("absolute pin-b pin-r pin-l")}>
                                <Paper className="flex items-center relative rounded-10" elevation={1}>
                                    <TextField
                                        autoFocus={true}
                                        id="interacao"
                                        className="flex-1"
                                        InputProps={{
                                            disableUnderline: true,
                                            classes: {
                                                root: "flex flex-grow flex-no-shrink ml-16 mr-48 my-8",
                                                input: ""
                                            },
                                            placeholder: "Mensagem"
                                        }}
                                        InputLabelProps={{ shrink: false }}
                                        onChange={ev => setInteracao(ev.target.value)}
                                        value={interacao}
                                        onKeyPress={(ev) => {
                                            if (ev.key === 'Enter') {
                                                enviar();
                                            }
                                        }}
                                    />
                                    <XAPPButton
                                        type="Icon"
                                        className="absolute pin-r pin-t"
                                        onClick={() => enviar()}
                                        icon={"send"}
                                    />
                                </Paper>
                            </div>
                        }
                    </div>
                </FuseAnimate>
            }
        </React.Fragment>
    );
}

const MenuOpcoes = ({ interacao }) => {

    const [openOpcoes, setOpenOpcoes] = useState(null);
    const [openDetalhes, setOpenDetalhes] = useState(false);
    return (
        <React.Fragment>
            <XAPPButton
                type="Icon"
                className={clsx("btn-opcoes p-px absolute pin-t pin-r rounded-t-none rounded-b-8")}
                variant="contained"
                onClick={ev => setOpenOpcoes(ev.currentTarget)}
                iconProps={"justify-center text-24"}
                icon={"arrow_down"}
            />
            <Menu
                id="menu-opcoes"
                anchorEl={openOpcoes}
                open={Boolean(openOpcoes)}
                onClose={() => setOpenOpcoes(null)}
            >
                <MenuItem
                    onClick={() => {
                        setOpenDetalhes(true);
                        setOpenOpcoes(null);
                    }}
                    key={"Detalhes_" + interacao.idmensageminteracao}
                >
                    <ListItemIcon>
                        <MdInfoOutline className="mr-0" color="action" />
                    </ListItemIcon>
                    <ListItemText primary={"Detalhes"} disableTypography={true} />
                </MenuItem>
            </Menu>
            <DialogDetalhes
                open={openDetalhes}
                onClose={() => setOpenDetalhes(false)}
                interacao={interacao}
            />
        </React.Fragment>
    );
}

const DialogDetalhes = ({ interacao, open, onClose }) => {

    return (
        <React.Fragment>
            <XAPPDialog
                id="Chat"
                open={open}
                onClose={onClose}
                fullWidth
                maxWidth="xs"
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {"Detalhes da mensagem"}
                        </Typography>
                        <div className="flex-1" />
                        <XAPPButton
                            type="Icon"
                            className="p-6"
                            variant="contained"
                            onClick={onClose}
                            iconProps={"justify-center"}
                            icon={"close"}
                        />
                    </Toolbar>
                </AppBar>
                <DialogContent className="p-16 overflow-hiden">
                    <div className="w-full flex flex-col">
                        <Typography className="inline font-medium text-15 capitalize" color="textSecondary">
                            {`De: ${(interacao.nome ?? "").toLowerCase()}`}
                        </Typography>
                        <Typography className="inline font-medium text-15" color="textSecondary">
                            {`Enviado em: ${dayjs(interacao.datains).format("DD/MM/YYYY")} às ${dayjs(interacao.datains).format("HH:mm")}`}
                        </Typography>
                    </div>
                    <Typography className="inline font-medium text-15" color="textSecondary">
                        {`Lido por:`}
                    </Typography>
                    <div className="overflow-y-auto max-h-320 mt-4">
                        {!_.isNull(interacao.protocolo) && _.filter(interacao.protocolo, { lido: 1 }).map(item => (
                            <div className={clsx("flex flex-row w-full px-8 items-center gap-8 min-h-44 border-1 mb-8")}>
                                <Avatar
                                    alt={`Foto_${item.nome}`}
                                    src={""}
                                    className="h-32 w-32 text-16"
                                >
                                    {getAcronimo(item.nome)}
                                </Avatar>
                                <div className={clsx("flex flex-col w-1/3")}>
                                    <Typography className="text-11 whitespace-no-wrap capitalize" color="textSecondary">
                                        {(item.nome ?? "").toLowerCase()}
                                    </Typography>
                                    <Typography className="text-11 whitespace-no-wrap" color="textSecondary">
                                        {isHoje(item.leitura) ? `hoje às ${dayjs(item.leitura).format("HH:mm")}` : dayjs(item.leitura).format("DD/MM/YYYY às HH:mm")}
                                    </Typography>
                                </div>
                            </div>
                        ))}
                    </div>
                </DialogContent>
            </XAPPDialog>
        </React.Fragment>
    );
}


export default withStyles(styles, { withTheme: true })(Chat);